// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#focus--m5bSu:focus {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: var(--bo-ui-focus-outline-offset, 2px);
  border-radius: 0.25rem;
}
@supports selector(:focus-visible) {
  #focus--m5bSu:focus {
    outline: none;
    outline-offset: 0;
    border-radius: 0.25rem;
  }
  #focus--m5bSu:focus-visible {
    outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
    outline-offset: var(--bo-ui-focus-outline-offset, 2px);
    border-radius: 0.25rem;
  }
}
#focus-within--h2zHN:focus-within {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: 0px;
  border-radius: 0.25rem;
}
#barOnBottom--CJUjT {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #00217D;
  height: 6px;
  border-radius: 4px 4px 0px 0px;
}
.navButton--mxNpK {
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.navButton--mxNpK:last-child {
  margin-right: 0;
}
.navButton--mxNpK:hover::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #00217D;
  height: 6px;
  border-radius: 4px 4px 0px 0px;
}
.navButton--mxNpK.active--qpgsP::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #00217D;
  height: 6px;
  border-radius: 4px 4px 0px 0px;
}
.navButton--mxNpK button {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.navButton--mxNpK button:focus {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: var(--bo-ui-focus-outline-offset, 2px);
  border-radius: 0.25rem;
}
@supports selector(:focus-visible) {
  .navButton--mxNpK button:focus {
    outline: none;
    outline-offset: 0;
    border-radius: 0.25rem;
  }
  .navButton--mxNpK button:focus-visible {
    outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
    outline-offset: var(--bo-ui-focus-outline-offset, 2px);
    border-radius: 0.25rem;
  }
}
.navButton--mxNpK button span {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: #1A202C;
  line-height: 1.125rem;
}
.navButton--mxNpK button:hover {
  text-decoration: none;
}
.navButton--mxNpK button path {
  stroke: #1A202C;
}
.navbarIcon--GCDn8 {
  width: 18px;
  height: 18px;
}
.accountIcon--vtXHL {
  stroke: white !important;
  width: 20px;
  height: 20px;
}
.accountMenu--oEnLI {
  display: flex;
  justify-content: flex-end;
}
.accountButton--zKCBM {
  border-radius: 2rem;
}
.accountButton--zKCBM:focus {
  border-radius: 2rem;
}
.basketCounter--q3dCj {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 10px;
  right: 8px;
  width: 16px;
  height: 16px;
  font-size: 0.75rem;
  pointer-events: none;
  background: #00217D;
  color: #FFF;
  border-radius: 100%;
  font-weight: 500;
}
.menu--pkSLw {
  padding: 0 1rem;
}
.tooltip--Jr2z3 {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  position: absolute;
  width: 250px;
  top: 71px;
  height: auto;
  padding-bottom: 1rem;
  background: white;
  box-shadow: 0px 2px 10px #e8e8e8;
  border-radius: 4px;
  z-index: 1;
  color: #1A202C;
  cursor: auto;
}
.tooltip--Jr2z3 a,
.tooltip--Jr2z3 button {
  color: inherit;
}
.tooltip--Jr2z3 a:hover,
.tooltip--Jr2z3 button:hover {
  text-decoration: underline;
}
.menuItem--HkCS6 {
  flex-direction: row;
  justify-content: space-between;
}
.menuItem--HkCS6 p {
  padding-top: 4px;
}
.headerButton--tCLtQ {
  flex-direction: column;
  padding: 0 0.75rem;
  margin: 0 0.25rem;
  white-space: nowrap;
}
.accountButton--zKCBM {
  flex-direction: row;
  justify-content: left !important;
  padding: 0 0.75rem;
  background: #193DA1;
  color: white;
  margin: 13px 0;
  text-align: left;
  width: -moz-fit-content;
  width: fit-content;
  white-space: nowrap;
}
.accountButton--zKCBM svg {
  stroke: white;
  height: 30px !important;
}
.platformGuideIcon--lZVyY {
  padding-left: 8px;
}
.platformGuideIcon--lZVyY svg {
  height: 14px;
  width: 14px;
  display: inherit;
}
.expiryDate--nnGIi {
  border-bottom: 1px solid #2D3748;
  border-top: 1px solid #2D3748;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@boclips-ui/styles/src/focus.less","webpack://./src/components/navButtons/newstyle.module.less"],"names":[],"mappings":"AAIE;EACE,sDAAA;EACA,sDAAA;EACA,sBAAA;ACHJ;ADUE;EACE;IACE,aAAA;IACA,iBAAA;IACA,sBAAA;ECRJ;EDUE;IACE,sDAAA;IACA,sDAAA;IACA,sBAAA;ECRJ;AACF;ADaE;EACE,sDAAA;EACA,mBAAA;EACA,sBAAA;ACXJ;AAlBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,8BAAA;AAoBF;AAhBA;EAAA,kBAAA;EAAA,mBAAA;EAAA,uBAAA;EACE,aAAA;EACA,sBAAA;EACA;AAHF;AAKE;EACE,eAAA;AAmBJ;AAfI;EArBF,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,8BAAA;AAuCF;AAnBI;EA3BF,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,8BAAA;AAiDF;AA9CA;EAuBI,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AA0BJ;AD/DE;EACE,sDAAA;EACA,sDAAA;EACA,sBAAA;ACiEJ;AD1DE;EACE;IACE,aAAA;IACA,iBAAA;IACA,sBAAA;EC4DJ;ED1DE;IACE,sDAAA;IACA,sDAAA;IACA,sBAAA;EC4DJ;AACF;AAvCI;EAAA,mBAAA;EAAA,kBAAA;EAAA,gBAAA;EACE,cAAA;EACA;AAFF;AAKA;EACE,qBAAA;AAyCN;AA9EA;EAyCM,eAAA;AAwCN;AAnCA;EACE,WAAA;EACA,YAAA;AAqCF;AAlCA;EACE,wBAAA;EACA,WAAA;EACA,YAAA;AAoCF;AAjCA;EACE,aAAA;EACA,yBAAA;AAmCF;AAhCA;EACE,mBAAA;AAkCF;AAhCG;EACE,mBAAA;AAkCL;AA9BA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAgCF;AA7BA;EACE,eAAA;AA+BF;AA5BA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;AA8BF;AA7CA;;EAmBI,cAAA;AA8BJ;AA5BI;;EACE,0BAAA;AA+BN;AA1BA;EACE,mBAAA;EACA,8BAAA;AA4BF;AA9BA;EAKI,gBAAA;AA4BJ;AAxBA;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AA0BF;AAvBA;EACE,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;AAyBF;AAlCA;EAYI,aAAA;EACA,uBAAA;AAyBJ;AArBA;EACE,iBAAA;AAuBF;AAxBA;EAII,YAAA;EACA,WAAA;EACA,gBAAA;AAuBJ;AAnBA;EACE,gCAAA;EACA,6BAAA;AAqBF","sourcesContent":["@import './vars';\n\n#focus {\n  // For any browser that doesn't focus-visible (Safari)\n  &:focus {\n    outline: @focus-outline;\n    outline-offset: @focus-outline-offset;\n    border-radius: .25rem;\n  }\n\n  // For browsers that do support focus-visible:\n  // - turn off focus styles\n  // - apply styles only to focus-visible\n  // https://www.tpgi.com/focus-visible-and-backwards-compatibility/\n  @supports selector(:focus-visible) {\n    &:focus {\n      outline: none;\n      outline-offset: 0;\n      border-radius: .25rem;\n    }\n    &:focus-visible {\n      outline: @focus-outline;\n      outline-offset: @focus-outline-offset;\n      border-radius: .25rem;\n    }\n  }\n}\n\n#focus-within{\n  &:focus-within {\n    outline: @focus-outline;\n    outline-offset: 0px;\n    border-radius: .25rem;\n  }\n}\n","@import '~@boclips-ui/styles/src/colors';\n@import '~@boclips-ui/styles/src/focus';\n\n#barOnBottom {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  background-color: @blue-800;\n  height: 6px;\n  border-radius: 4px 4px 0px 0px;\n}\n\n.navButton {\n@apply items-center justify-center relative;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  &:hover {\n    &::after {\n      #barOnBottom();\n    }\n  }\n\n  &.active {\n    &::after {\n      #barOnBottom();\n    }\n  }\n\n  button {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    #focus();\n\n    span {\n    @apply text-xxs mt-1 font-medium;\n      color: @gray-900;\n      line-height: 1.125rem;\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n\n    path {\n      stroke: @gray-900;\n    }\n  }\n}\n\n.navbarIcon {\n  width: 18px;\n  height: 18px;\n}\n\n.accountIcon {\n  stroke: white !important;\n  width: 20px;\n  height: 20px;\n}\n\n.accountMenu {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.accountButton {\n  border-radius: 2rem;\n\n   &:focus {\n     border-radius: 2rem;\n   }\n}\n\n.basketCounter {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 10px;\n  right: 8px;\n  width: 16px;\n  height: 16px;\n  font-size: 0.75rem;\n  pointer-events: none;\n  background: @blue-800;\n  color: @white;\n  border-radius: 100%;\n  font-weight: 500;\n}\n\n.menu {\n  padding: 0 1rem;\n}\n\n.tooltip {\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  position: absolute;\n  width: 250px;\n  top: 71px;\n  height: auto;\n  padding-bottom: 1rem;\n  background: white;\n  box-shadow: 0px 2px 10px #e8e8e8;\n  border-radius: 4px;\n  z-index: 1;\n  color: @gray-900;\n  cursor: auto;\n\n  a,\n  button {\n    color: inherit;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.menuItem {\n  flex-direction: row;\n  justify-content: space-between;\n\n  p {\n    padding-top: 4px;\n  }\n}\n\n.headerButton {\n  flex-direction: column;\n  padding: 0 0.75rem;\n  margin: 0 0.25rem;\n  white-space: nowrap;\n}\n\n.accountButton {\n  flex-direction: row;\n  justify-content: left !important;\n  padding: 0 0.75rem;\n  background: @blue-700;\n  color: white;\n  margin: 13px 0;\n  text-align: left;\n  width: fit-content;\n  white-space: nowrap;\n\n  svg {\n    stroke: white;\n    height: 30px !important;\n  }\n}\n\n.platformGuideIcon {\n  padding-left: 8px;\n\n  svg {\n    height: 14px;\n    width: 14px;\n    display: inherit;\n  }\n}\n\n.expiryDate {\n  border-bottom: 1px solid @gray-800;\n  border-top: 1px solid @gray-800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"focus": `focus--m5bSu`,
	"focus-within": `focus-within--h2zHN`,
	"barOnBottom": `barOnBottom--CJUjT`,
	"navButton": `navButton--mxNpK`,
	"active": `active--qpgsP`,
	"navbarIcon": `navbarIcon--GCDn8`,
	"accountIcon": `accountIcon--vtXHL`,
	"accountMenu": `accountMenu--oEnLI`,
	"accountButton": `accountButton--zKCBM`,
	"basketCounter": `basketCounter--q3dCj`,
	"menu": `menu--pkSLw`,
	"tooltip": `tooltip--Jr2z3`,
	"menuItem": `menuItem--HkCS6`,
	"headerButton": `headerButton--tCLtQ`,
	"platformGuideIcon": `platformGuideIcon--lZVyY`,
	"expiryDate": `expiryDate--nnGIi`
};
export default ___CSS_LOADER_EXPORT___;
